type SpeechRecognitionCtor = new () => SpeechRecognitionInstance;

interface SpeechRecognitionInstance {
  continuous: boolean;
  interimResults: boolean;
  lang: string;
  start(): void;
  stop(): void;
  abort(): void;
  onresult: ((e: SpeechRecognitionEventLike) => void) | null;
  onerror: ((e: { error: string }) => void) | null;
  onend: (() => void) | null;
}

interface SpeechRecognitionEventLike {
  results: ArrayLike<{ 0: { transcript: string }; isFinal: boolean }>;
  resultIndex: number;
}

function getCtor(): SpeechRecognitionCtor | null {
  const w = globalThis as unknown as {
    SpeechRecognition?: SpeechRecognitionCtor;
    webkitSpeechRecognition?: SpeechRecognitionCtor;
  };
  return w.SpeechRecognition ?? w.webkitSpeechRecognition ?? null;
}

export function isVoiceSupported(): boolean {
  return getCtor() !== null;
}

export interface VoiceRecorderOptions {
  silenceTimeoutMs: number;
  onInterim: (text: string) => void;
  onFinal: (text: string) => void;
  onError: (err: string) => void;
  onEnd: () => void;
}

export function startVoiceRecording(opts: VoiceRecorderOptions): { stop: () => void } {
  const Ctor = getCtor();
  if (!Ctor) {
    opts.onError('not-supported');
    return { stop: () => {} };
  }
  const recog = new Ctor();
  recog.continuous = true;
  recog.interimResults = true;
  recog.lang = 'ja-JP';

  let silenceTimer: number | null = null;
  let finalText = '';
  const resetSilence = () => {
    if (silenceTimer) clearTimeout(silenceTimer);
    silenceTimer = window.setTimeout(() => recog.stop(), opts.silenceTimeoutMs);
  };

  recog.onresult = (e) => {
    let interim = '';
    for (let i = e.resultIndex; i < e.results.length; i++) {
      const r = e.results[i]!;
      if (r.isFinal) finalText += r[0].transcript;
      else interim += r[0].transcript;
    }
    if (interim) opts.onInterim(finalText + interim);
    if (finalText) opts.onInterim(finalText);
    resetSilence();
  };
  recog.onerror = (e) => opts.onError(e.error);
  recog.onend = () => {
    if (silenceTimer) clearTimeout(silenceTimer);
    if (finalText) opts.onFinal(finalText.trim());
    opts.onEnd();
  };

  recog.start();
  resetSilence();
  return { stop: () => recog.stop() };
}
